import {
  IP_INFO_URL, IP_INFO_KEY,
} from '../../constants';
import GetWeather from '../getWeather';

export default class SearchLocation {
  async getLocation() {
    this.location = await fetch(`${IP_INFO_URL}${IP_INFO_KEY}`)
      .then((location) => location.json());
    this.getWeaterInStartLocation(this.location.city.replace(/[\s.,'%]/g, ''));
  }

  getWeaterInStartLocation(qury) {
    this.weatherInMyLocation = new GetWeather();
    this.weatherInMyLocation.init(qury);
  }

  init() {
    this.getLocation();
  }
}
